export function isNullOrUndefinedOrEmpty(value: any) {
  return isNullOrUndefined(value) || value === '';
}

export function isNullOrUndefined(value: any) {
  return value === null || value === undefined;
}
